import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ShActionItemComponent } from '../../../../elements/components/action-item/action-item.component';
import { ShIconModule } from '../../../../elements/components/icon/icon.module';

import { ShClickOutsideDirective } from '../../../../elements/directives/click-outside/click-outside.directive';
import { ShFormInputWithDroppanelComponent } from './form-input-with-droppanel.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ShActionItemComponent,
        ShIconModule,
        ShFormInputWithDroppanelComponent,
        ShClickOutsideDirective
    ],
    exports: [ShFormInputWithDroppanelComponent]
})
export class ShFormInputWithDroppanelModule {}

export { ShFormInputWithDroppanelComponent } from './form-input-with-droppanel.component';
